
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1604297164923",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1445",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "74",
    "height": "74"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M488.6 651.5c4.3 2 9.3 2 13.7 0l234.1-111v159c0 6.1-3.4 11.7-8.9 14.5L502.6 827.4c-4.5 2.3-9.8 2.3-14.4 0L203.5 714.1c-5.5-2.7-8.9-8.3-8.9-14.5V540.5l294 111zM836 359v440.1c0 16.5-13.4 29.9-29.9 29.9s-29.9-13.4-29.9-29.9V371.4l-39.7 9.3v110.4l-241 114.2-300.9-114.2V377l-78-25.2c-6.2-2.4-10.3-8.4-10.3-15s4.1-12.6 10.3-15l372.9-149c3.8-1.5 8-1.5 11.8 0l373 149c6.1 2.5 10.2 8.4 10.2 15s-4 12.6-10.2 15L836 359z",
        "p-id": "1446"
      }
    }
  ]
})
    }
  